document.documentElement.classList.remove('no-js');

document.querySelectorAll('[data-vehicle-finder]').forEach((form) => {
  const model = form.querySelector('[data-model-select]');
  const generation = form.querySelector('[data-generation-select]');
  if (!model || !generation) return;
  // Liquid supplies localized collection URLs; keep navigation in the chosen market.
  const options = [...generation.options].map((option) => option.cloneNode(true));
  const sync = () => {
    const matching = options.filter((option) => option.dataset.model === model.value);
    generation.replaceChildren(...matching.map((option) => option.cloneNode(true)));
  };
  model.addEventListener('change', sync);
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (generation.value) window.location.assign(generation.value);
  });
  sync();
});

const toggle = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
const setMobileMenu = (open, restoreFocus = false) => {
  if (!toggle || !mobileMenu) return;
  toggle.setAttribute('aria-expanded', String(open));
  mobileMenu.hidden = !open;
  if (!open) {
    mobileMenu.querySelectorAll('details[open]').forEach((detail) => { detail.open = false; });
    if (restoreFocus) toggle.focus();
  }
};
if (toggle && mobileMenu) {
  toggle.addEventListener('click', () => setMobileMenu(mobileMenu.hidden));
  mobileMenu.addEventListener('click', (event) => {
    if (event.target.closest('a[href]')) setMobileMenu(false);
  });
  document.addEventListener('pointerdown', (event) => {
    if (!mobileMenu.hidden && !event.target.closest('[data-site-header]')) setMobileMenu(false);
  });
  const desktopViewport = window.matchMedia('(min-width: 1051px)');
  desktopViewport.addEventListener('change', (event) => {
    if (event.matches) setMobileMenu(false);
  });
}

document.querySelectorAll('[data-sort-by]').forEach((select) => {
  const current = new URL(window.location.href);
  select.value = current.searchParams.get('sort_by') || 'manual';
  select.addEventListener('change', () => {
    current.searchParams.set('sort_by', select.value);
    window.location.href = current.toString();
  });
});

// Accessible desktop mega-menu: hover and keyboard open it; outside click and Escape close it.
const desktopDropdowns = [...document.querySelectorAll('.desktop-nav .nav-dropdown')];
const setDropdownState = (dropdown, open) => {
  dropdown.open = open;
  dropdown.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(open));
};
const closeDesktopDropdowns = (except = null) => {
  desktopDropdowns.forEach((dropdown) => {
    if (dropdown !== except) setDropdownState(dropdown, false);
  });
};

desktopDropdowns.forEach((dropdown) => {
  const summary = dropdown.querySelector(':scope > summary');
  if (!summary) return;
  let closeTimer;

  dropdown.addEventListener('mouseenter', () => {
    window.clearTimeout(closeTimer);
    closeDesktopDropdowns(dropdown);
    setDropdownState(dropdown, true);
  });
  dropdown.addEventListener('mouseleave', () => {
    closeTimer = window.setTimeout(() => setDropdownState(dropdown, false), 180);
  });
  dropdown.addEventListener('focusin', (event) => {
    window.clearTimeout(closeTimer);
    closeDesktopDropdowns(dropdown);
    if (event.target !== summary) setDropdownState(dropdown, true);
  });
  dropdown.addEventListener('focusout', (event) => {
    if (!dropdown.contains(event.relatedTarget)) {
      closeTimer = window.setTimeout(() => setDropdownState(dropdown, false), 100);
    }
  });
  dropdown.addEventListener('toggle', () => {
    summary.setAttribute('aria-expanded', String(dropdown.open));
  });
});

document.addEventListener('pointerdown', (event) => {
  if (!event.target.closest('.desktop-nav')) closeDesktopDropdowns();
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    if (mobileMenu && !mobileMenu.hidden) setMobileMenu(false, true);
    const openDropdown = document.querySelector('.desktop-nav .nav-dropdown[open]');
    if (openDropdown) {
      const summary = openDropdown.querySelector(':scope > summary');
      setDropdownState(openDropdown, false);
      summary?.focus();
    }
  }
});

// Keep privacy choices available after the regional Shopify banner is dismissed.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-cookie-preferences]');
  if (!trigger) return;

  event.preventDefault();
  if (window.privacyBanner?.showPreferences) {
    window.privacyBanner.showPreferences();
  }
});
